import { SplitOrderRouteService } from 'common/data';
import { BaseService } from 'core/services';
import _ from 'lodash';

class SplitOrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new SplitOrderRouteService());
	}

	splitOrderAsync(orderId, sourceOfChange) {
		var url = this.routeService.splitOrderAsync(orderId, sourceOfChange);
		return this.apiClient.get(url);
	}
}
export default SplitOrderService;
